import React from "react";
import { Field, FieldProps } from "formik";
import { WintSuperkollAPIModelWintSalary } from "wint-api-client/dist/types";
import { SelectionItem } from "models/utilTypes/selectionTypes";
import SelectionGroup from "components/common/selection/selectionGroup";
import cssExports from "theme/styles/main.module.scss";

interface SalaryTypeSelectorProps {
  name: string;
  availableSalaryTypes: WintSuperkollAPIModelWintSalary.WintSalaryType[];
}

const SalaryTypeSelector: React.FC<SalaryTypeSelectorProps> = ({ name, availableSalaryTypes }) => {
  const salaryTypeItems: SelectionItem[] = availableSalaryTypes.map((type) => ({
    id: type.name || "",
    value: type.name || "",
  }));

  const descriptions: Record<string, string> = availableSalaryTypes.reduce((acc, type) => {
    if (type.name && type.description) {
      acc[type.name] = type.description;
    }
    return acc;
  }, {} as Record<string, string>);

  return (
    <Field name={name}>
      {({ field, form }: FieldProps) => {
        const selectedItem = salaryTypeItems.find((x) => x.id === field.value);

        return (
          <>
            <SelectionGroup
              className={cssExports.employeeSalaryTypeSelector}
              items={salaryTypeItems}
              value={selectedItem ? [selectedItem] : []}
              onChange={(items) => {
                if (items.length > 0) {
                  form.setFieldValue(name, items[0].id);
                }
              }}
              hideViewAll
            />

            {/* Dynamic description */}
            {field.value && descriptions[field.value] && (
              <div className={cssExports.formControlDescription}>{descriptions[field.value]}</div>
            )}
          </>
        );
      }}
    </Field>
  );
};

export default SalaryTypeSelector;
